"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonFieldLogic = void 0;
const field_logic_1 = require("../../field-type-registry/field-logic");
const types_1 = require("@smartsuite/types");
const intl_1 = require("../../locale/intl");
const button_fieldtype_1 = require("../../safe-field-value/button-field/button.fieldtype");
const texts_1 = require("../../texts");
class ButtonFieldLogic extends field_logic_1.BaseFieldTypeLogic {
    constructor() {
        super(...arguments);
        this.name = "buttonfield";
        this.label = (0, intl_1.$t)(texts_1.buttonFieldText.button);
        this.icon = "button-field";
        this.iconColor = types_1.Colors.bRed;
        this.fieldValueGetter = new button_fieldtype_1.ButtonFieldValueGetter();
        this.aggregates = {};
    }
    getViewControlRules(field) {
        return {
            ...super.getViewControlRules(field),
            fieldInSort: "disable",
            fieldInFilter: "disable",
            fieldInGroup: "disable",
            fieldInSpotlight: "disable",
            disableFieldInTextSearch: "disable",
        };
    }
    groupByKey(_fieldValue, _field) {
        return "";
    }
    isValueEmpty(_fieldValue) {
        return false;
    }
    getLinkedRecordFieldSmartWidth(_field) {
        return { defaultWidht: 80, minWidth: 40 };
    }
    valueToExport(fieldValue, field, userPreferences, record) {
        var _a, _b, _c;
        if (fieldValue) {
            return this.valueToString(fieldValue, field, userPreferences, record);
        }
        // @ts-expect-error: poor typing
        return ((_c = (_b = (_a = field === null || field === void 0 ? void 0 : field.params) === null || _a === void 0 ? void 0 : _a.button_actions_params) === null || _b === void 0 ? void 0 : _b.open_url) === null || _c === void 0 ? void 0 : _c.static_url) || "";
    }
}
exports.ButtonFieldLogic = ButtonFieldLogic;
